import React from "react";

import { isNil } from "lodash";

import { Stack, Text, Flex, Icon } from "@chakra-ui/react";
import { CheckIcon } from "@heroicons/react/outline";

import { Option } from "../../../../types";

import AnswerFrom from "./AnswerForm";
import AnswerCommentReview from "./AnswerCommentReview";
import AnswerTimeSpentReview from "./AnswerTimeSpentReview";

import { AnswerReviewProps } from "./types/AnswerReviewProps";

const AnswerSelectorSingleReview: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, question, path }) => {
    const selectedOption = (question.options as Option[])?.find(
      ({ value }) => value === answer.value?.selector
    );

    return (
      <Stack spacing="4">
        <AnswerFrom {...{ answer, path, omit: answer.isEmpty }} />
        {selectedOption && (
          <Flex
            maxWidth="2xl"
            w="full"
            id={`${path}.answer.${answer.id}.value`}
            bgColor="brand"
            direction="row"
            px="5"
            py="4"
            justify="space-between"
            rounded="xl"
          >
            <Text
              color="white"
              fontWeight="medium"
              fontSize="md"
              id={`${path}.answer.${answer.id}.value.${selectedOption?.value}`}
            >
              {selectedOption.label}
            </Text>
            <Icon as={CheckIcon} w="6" h="6" flexShrink={0} color="white" />
          </Flex>
        )}
        {answer.value?.comment && (
          <AnswerCommentReview {...{ answer, question, path }} />
        )}
        {!isNil(answer.timeSpent) && (
          <AnswerTimeSpentReview {...{ answer, question, path }} />
        )}
      </Stack>
    );
  }
);

export default AnswerSelectorSingleReview;
